var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBackArrow = function SvgBackArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "main-color-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.475,
    height: 12.595
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m.364 7.162 5.081 5.081a1.214 1.214 0 0 0 1.717-1.717l-3-3.018h11.1a1.214 1.214 0 0 0 0-2.428h-11.1l3-3A1.22 1.22 0 1 0 5.428.363L.364 5.427A1.235 1.235 0 0 0 0 6.299a1.166 1.166 0 0 0 .364.863Z"
  })));
};
export default SvgBackArrow;